<template>
    <!-- 全选内容 -->
    <el-dialog title="选择" :visible.sync="dialogSelectData.visible" :close-on-click-modal="false" width="50%">
        <template v-if="dialogSelectData.visible">
            <el-transfer v-model="selectVal" class="myTransfer" :titles="[`未选${traineeType ===
                'dept'
                ? '部门' : '人员'}`, `已选${traineeType ===
                    'dept'
                    ? '部门' : '人员'}`]" filterable
                :filter-placeholder="`请输入${traineeType === 'dept' ? '部门名称' : '人员名称或者部门名称'}`"
                :data="traineeType === 'dept' ? transferDeptData : transferUserData"></el-transfer>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="confirmSelect()">确 定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script>
import { archiveList } from '@/api/employee';
import { deptTree, deptList } from '@/api/dept';
export default {
    props: {
        traineeType: {
            type: String,
            default: 'dept'
        },
        dialogSelectData: {
            type: Object,
            default: () => {
                return {
                    visible: false,
                    selectVal: [],
                    data: []
                }
            }
        }
    },
    data () {
        return {
            formInline: {
                deptId: '',
            },
            selectVal: [],
            transferUserData: [],
            selectTraineeLabel: '',
            deptTreeData: [],
            transferDeptData: [],
        }
    },
    watch: {
        'dialogSelectData.visible' (i, j) {
            if (i) {
                this.selectVal = this.dialogSelectData.selectVal;
            }
        }
    },
    created () {
        deptTree().then(res => {
            this.deptTreeData = res.data
        })
        this.init()

    },
    methods: {
        async init () {
            let res = null;
            res = await deptList({
                "pageNum": 1,
                "pageSize": 9999
            })
            this.transferDeptData = res.data.map(i => { return { key: i.deptId, label: i.deptName } })
            this.getArchiveList()
        },
        async getArchiveList () {
            const params = {};
            if (this.formInline.deptId) {
                params.deptId = this.formInline.deptId
            }
            const res = await archiveList(params);
            this.transferUserData = res.data.map(i => { return { key: i.archiveId, label: i.userName + `(${i.deptName})` } })
        },
        cancel () {
            this.$emit('cancel')
        },
        confirmSelect () {
            const transferData = this.traineeType === 'dept' ? this.transferDeptData : this.transferUserData
            this.selectTraineeLabel = transferData.filter(i => this.selectVal.includes(i.key)).map(i => i.label).toString()
            // this.dialogSelectData.visible = false;
            this.$emit('confirmSelect', this.selectVal, this.selectTraineeLabel)
        }
    }
}
</script>
<style>
.myTransfer .el-transfer-panel {
    width: 4.666667rem;
}
</style>


// WEBPACK FOOTER //
// src/components/myTransfer.vue